<template>
  <div :class="containerClasses">
    <div v-if="label" :for="uniqid" class="Form-input__label">
      {{ label }}
    </div>

    <div class="Radio-input">
      <input
        v-confirm-dialog="confirm"
        :id="uniqid"
        :checked="checked"
        :disabled="disabled"
        type="radio"
        class="Radio-input__input"
        @change="updateChecked($event.target.checked)"
      />
      <label class="Radio-input__radio" :for="uniqid">
        {{ text }}
      </label>
    </div>
  </div>
</template>

<script>
import formInputMixin from "./form-input-mixin";

export default {
  name: "RadioInput",
  mixins: [formInputMixin],
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Object
    }
  },
  methods: {
    updateChecked(isChecked) {
      if (!this.confirm) {
        this.$emit("touch");
        this.$emit("input", isChecked, this.value);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
